const invalidUpdates = [];
export const storeInvalidUpdates = (newInvalidUpdates) => invalidUpdates.push(newInvalidUpdates);
window.addEventListener('ssppvidset', () => (invalidUpdates.length = 0));
export const getInvalidUpdatesForBe = () => {
    const invalidUpdatesForBe = invalidUpdates.reduce((acc, { identity, value, type }) => {
        if (['aid', 'eid', 'tid'].includes(identity)) {
            acc = Object.assign(Object.assign({}, acc), { [identity]: value });
        }
        if (identity === 'login' && type === 'timeout') {
            acc.loginTimeout = true;
        }
        return acc;
    }, {});
    return Object.keys(invalidUpdatesForBe).length ? invalidUpdatesForBe : null;
};
export const getInvalidUpdates = () => invalidUpdates;
